// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as React from "react";
import * as Firebase from "../../backend/Firebase.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Reactfire from "../../backend/Reactfire.bs.jsx";
import * as Reactfire$1 from "reactfire";
import * as Auth from "rxfire/auth";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Firestore from "rxfire/firestore";
import * as NotificationHooks from "../../backend/NotificationHooks.bs.jsx";

function isSubscribedToNotificationsRx(auth, firestore, placeId) {
  let currentUserRx = Rxjs.op(Auth.user(auth), Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  let placeRef = Db.placeDocument(firestore, placeId);
  let placeRx = Firestore.docData(placeRef, { "idField": "uid" });
  return Rxjs.op(Rxjs$1.combineLatest(currentUserRx, placeRx), Rxjs$1.map((param, param$1) => {
    let place = param[1];
    if (place !== undefined) {
      return Stdlib_Option.getOr(Stdlib_Option.map(place.accounts[param[0].uid], param => param[1] > 0), false);
    } else {
      return false;
    }
  }));
}

let make = React.memo(props => {
  if (import.meta.env.PROD && NotificationHooks.canSubscribe) {
    let auth = Reactfire$1.useAuth();
    let firestore = Reactfire$1.useFirestore();
    let messaging = Reactfire.useMessaging();
    let updateNotificationToken = NotificationHooks.useUpdateNotificationToken();
    let isSubscribedToNotifications = Reactfire$1.useObservable("isSubscribedToNotifications", isSubscribedToNotificationsRx(auth, firestore, props.placeId));
    React.useEffect(() => {
      let match = isSubscribedToNotifications.data;
      if (match !== undefined && match) {
        Stdlib_Promise.$$catch(Firebase.Messaging.getToken(messaging).then(updateNotificationToken).then(param => Promise.resolve()), error => {
          let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
          if ((exn.code !== "messaging/permission-blocked")) {
            LogUtils.captureException(exn);
          }
          return Promise.resolve();
        });
      }
    }, [isSubscribedToNotifications.data]);
  }
  return null;
});

export {
  isSubscribedToNotificationsRx,
  make,
}
/* make Not a pure module */
